import { ProductPageLayout } from '../components/ProductPageLayout';

export function Veo3PromptPage() {
    return <ProductPageLayout productId="veo3-prompt" />;
}
